<template>
  <div class="wrap-box">
    <div class="wrap-box-left">
      <Form ref="searchForm" :model="searchForm">
        <div v-if="isAdvanceSearch">
          <Row>
              <Col :xs="24" :sm="24" :lg="8">
                <FormItem :label-width="90" :label="$t('label.project.country')" style="margin-bottom: 10px;">
                  <Select transfer filterable v-model="searchForm.country" :max-tag-count="0" class="" clearable multiple :placeholder="$t('label.country')">
                    <Icon v-if="searchForm.country && searchForm.country.length > 0" type="md-close-circle" slot="prefix" style="display: flex;" @click.stop="searchForm.country=[]"/>
                    <template v-for="par in countryList">
                      <OptionGroup :label="par.title">
                        <Option v-for="child in par.children" :key="child.id" :value="JSON.stringify(child)">
                          {{ child.title }}
                        </Option>
                      </OptionGroup>
                    </template>
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :lg="8">
                <FormItem :label-width="90" :label="$t('label.project.industry')" style="margin-bottom: 10px;">
                  <Select transfer filterable v-model="searchForm.industry" :max-tag-count="0" class="" clearable multiple :placeholder="$t('label.industry')">
                    <Icon v-if="searchForm.industry && searchForm.industry.length > 0" type="md-close-circle" slot="prefix" style="display: flex;" @click.stop="searchForm.industry=[]"/>
                    <Option v-for="item in industryList" :key="item.id" :value="JSON.stringify(item)">{{
                        item.title
                      }}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :lg="8">
                <FormItem :label-width="90" :label="$t('label.project.category')" style="margin-bottom: 10px;">
                  <Select transfer filterable v-model="searchForm.category" :max-tag-count="0" class="" clearable multiple
                          :placeholder="$t('label.category')">
                  <Icon v-if="searchForm.category && searchForm.category.length > 0" type="md-close-circle" slot="prefix" style="display: flex;" @click.stop="searchForm.category=[]"/>
                    <Option v-for="item in categoryList" :key="item.id" :value="JSON.stringify(item)">{{
                        item.title
                      }}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
          <Row>
            <Col :xs="24" :sm="24" :lg="8">
              <FormItem :label-width="90" :label="$t('label.project.enterprise')" style="margin-bottom: 10px;">
                <Select transfer filterable v-model="searchForm.company" :max-tag-count="0" clearable multiple :placeholder="$t('label.enterprise')">
                <Icon v-if="searchForm.company && searchForm.company.length > 0" type="md-close-circle" slot="prefix" style="display: flex;" @click.stop="searchForm.company=[]"/>
                  <Option v-for="item in companyList" :key="item.id" :value="JSON.stringify(item)">{{
                      item.title
                    }}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :lg="8">
              <FormItem :label-width="90" :label="$t('label.project.stage')" style="margin-bottom: 10px;">
                <Select transfer filterable v-model="searchForm.stage" :max-tag-count="0" clearable multiple :placeholder="$t('label.stage')">
                <Icon v-if="searchForm.stage && searchForm.stage.length > 0" type="md-close-circle" slot="prefix" style="display: flex;" @click.stop="searchForm.stage=[]"/>
                  <Option v-for="item in stageList" :key="item.id" :value="JSON.stringify(item)">{{
                      item.title
                    }}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :lg="8">
              <FormItem :label-width="90" :label="$t('label.project.amount')" style="margin-bottom: 10px;">
                <Select transfer filterable v-model="searchForm.amount" :max-tag-count="0" clearable multiple :placeholder="$t('label.amount')">
                <Icon v-if="searchForm.amount && searchForm.amount.length > 0" type="md-close-circle" slot="prefix" style="display: flex;" @click.stop="searchForm.amount=[]"/>
                  <Option v-for="item in amountList" :key="item.id" :value="JSON.stringify(item)">{{
                      item.title
                    }}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :lg="8">
              <FormItem :label-width="90" :label="$t('label.project.signDate')" style="margin-bottom: 10px;">
                <DatePicker
                  transfer
                  :value="searchForm.pdate"
                  :options="dateOptions"
                  @on-change="(val) => {searchForm.pdate = val}"
                  format="yyyy-MM-dd"
                  type="daterange"
                  :editable="false"
                  clearable
                  placement="bottom-start"
                  :placeholder="$t('label.signDate')"
                  style="width: 100%;">
                </DatePicker>
                <!--<Select transfer filterable  v-model="searchForm.date" :max-tag-count="1" clearable multiple :placeholder="$t('label.theDateRange')">
                  <Icon v-if="searchForm.date && searchForm.date.length > 0" type="md-close-circle" slot="prefix" style="display: flex;" @click.stop="searchForm.date=[]"/>
                  <Option v-for="item in dateList" :key="item.id" :value="JSON.stringify({id:item.id, title:item.title})">
                    {{ item.title }}
                  </Option>
                </Select>-->
              </FormItem>
            </Col>
          </Row>
        </div>
        <div style="margin-bottom: 10px;">
          <AutoComplete
              clearable
              v-model="searchForm.keywords"
              transfer
              @on-focus="()=> {this.associationWordsList=[]}"
              @on-search="associationWords"
              :placeholder="$t('placeholders.project.search')" class="auto-complete">
            <Option v-for="item in associationWordsList" :value="item" :key="item">{{ item }}</Option>
          </AutoComplete>
          <Button style="" type="primary" @click="search">{{ $t('buttons.search') }}</Button>

          <Button style="" @click="reset">{{ $t('buttons.reset') }}</Button>
          <el-link type="text" :underline="false" @click="openHistory" style="color: #008bce;cursor: pointer;" class="padding5" v-html="$t('buttons.searchHistory')"></el-link>
          <el-link v-if="isAdvanceSearch" class="padding5" type="default" :underline="false" @click="advanceSearchBtnClick(false)" v-html="$t('buttons.advanceRetrieval',{ type: 'up' })"></el-link>
          <el-link v-else class="padding5" type="default" :underline="false" @click="advanceSearchBtnClick(true)" v-html="$t('buttons.advanceRetrieval',{ type: 'down' })"></el-link>
        </div>
        <div v-if="isAdvanceSearch" v-show="Object.keys(myCondition).length > 0" class="my-condition-box">
          <label style="float:left;line-height: 27px;">{{ $t('label.project.searchCondition') }}：</label>
          <div style="margin-left: 110px;">
            <p v-for="(item,key) in myCondition">
              <label>{{ item.tag }}：</label>
              <template v-if="key === 'pdate'">
                <span class="condition-text">
                  {{ item.list.join(' - ') }}
                </span>
              </template>
              <template v-else>
                <span v-for="(obj,i) in item.list">
                  <span class="condition-text">
                    <i class="el-icon-error condition-item-close"
                       @click="item.list.splice(i,1)"></i>{{ JSON.parse(obj).title }}
                  </span>
                  {{ i === item.list.length - 1 ? '' : '，' }}
                </span>
              </template>
              <i class="el-icon-circle-close condition-close" @click="searchForm[key] = []"></i>
            </p>
          </div>

        </div>

      </Form>

      <GenerateReport ref="report" @exportSuccess="exportSuccessful"></GenerateReport>
      <el-tabs v-model="elTabsValue" type="card" :before-leave="changeTabState">
        <el-tab-pane lazy :label="$t('tabs.analysis.countryComparison')" name="country">
          <CountryAnalysis v-show="!projectShow" :condition="queryParams" @chartClick="chartClick" @closeShow="spinShow = false" :exportSuccess="exportSuccess"></CountryAnalysis>
        </el-tab-pane>
        <el-tab-pane lazy :label="$t('tabs.analysis.industryComparison')" name="industry">
          <IndustryAnalysis v-show="!projectShow" :condition="queryParams" @chartClick="chartClick" @closeShow="spinShow = false" :exportSuccess="exportSuccess"></IndustryAnalysis>
        </el-tab-pane>
        <el-tab-pane lazy :label="$t('tabs.analysis.opportunityAnalysis')" name="business">
          <BusinessOpportunityAnalysis v-show="!projectShow" :condition="queryParams" @closeShow="spinShow = false" :exportSuccess="exportSuccess"></BusinessOpportunityAnalysis>
        </el-tab-pane>
        <el-tab-pane lazy :label="$t('tabs.analysis.riskAnalysis')" name="rish">
          <RiskAnalysis v-show="!projectShow" :condition="queryParams" @closeShow="spinShow = false" :exportSuccess="exportSuccess"></RiskAnalysis>
        </el-tab-pane>
        <el-tab-pane lazy :label="$t('tabs.analysis.networkVolume')" name="network">
          <NetworkVolumeAnalysis v-show="!projectShow" :condition="queryParams" @closeShow="spinShow = false" :exportSuccess="exportSuccess"></NetworkVolumeAnalysis>
        </el-tab-pane>
        <el-tab-pane lazy :label="$t('tabs.analysis.positiveAndNegativeSidesOfInformation')" name="info">
          <InformationPositiveNegativeAnalysis v-show="!projectShow" :condition="queryParams" @closeShow="spinShow = false" :exportSuccess="exportSuccess"></InformationPositiveNegativeAnalysis>
        </el-tab-pane>
        <el-tab-pane v-if="!isSmall" name="more" class="more-btn" :label="$t('tabs.analysis.exportReport')"></el-tab-pane>
        <el-tab-pane name="project" :label="$t('tabs.analysis.projectList')">
          <AnalysisProject :condition="queryParams" ref="analysisRef"/>
        </el-tab-pane>
      </el-tabs>

    </div>
    <div class="wrap-box-right">
      <div class="pbr-title">{{ $t('label.analysis.atlasAnalysis') }}</div>
      <div style="height: 400px;">
        <AtlasAnalysis :graph="graphData" id="atlasAnalysis-graph-wrap"></AtlasAnalysis>
      </div>
      <div class="pbr-title">{{ $t('label.analysis.hotWordAnalysis') }}</div>
      <div style="height: 400px;">
        <HotWordAnalysis v-if="hotWordData && hotWordData.length" :word-data="hotWordData" @hotClick="hotClick"></HotWordAnalysis>
        <Empty v-else></Empty>
      </div>
    </div>
    <el-dialog :modal="false" :visible.sync="historyModal" append-to-body :title="$t('table.history.title')" width="600px">
      <div style="text-align: right;margin-bottom: 10px;">
        <Button @click="delAllHistory" type="primary">{{ $t('buttons.delAll') }}</Button>
      </div>
      <Table :columns="historyColumns" :data="historyTableData" border>
        <template slot="top" slot-scope="{ row }">
          <div style="cursor:pointer;" @click="toTopHistory(row)">
            <Icon :class="favIconClass(row)" style="font-size: 20px;"
                  type="md-arrow-round-up"/>
          </div>
        </template>
        <template slot="content" slot-scope="{ row }">
          <div @click="dblclickHistory(row)">
            {{ row.name }}
          </div>
        </template>
        <template slot="operate" slot-scope="{ row }">
          <Icon v-if="!row.del" style="font-size: 20px;cursor:pointer;" type="md-trash" @click="delHistory(row)"/>
        </template>
      </Table>
    </el-dialog>

<!--    <Spin v-if="spinShow" class="pbrSpin" fix size="large" />-->
  </div>
</template>

<script>
import CountryAnalysis from './CountryAnalysis'
import IndustryAnalysis from './IndustryAnalysis'
import NetworkVolumeAnalysis from './NetworkVolumeAnalysis'
import InformationPositiveNegativeAnalysis from './InformationPositiveNegativeAnalysis'
import BusinessOpportunityAnalysis from './BusinessOpportunityAnalysis'
import RiskAnalysis from './RiskAnalysis'
import AtlasAnalysis from './AtlasAnalysis'
import HotWordAnalysis from './HotWordAnalysis'
import GenerateReport from './GenerateReport'
import AnalysisProject from './AnalysisProject'
import Empty from '../components/Empty'

export default {
  name: 'Index', // 分析主页面
  components: {
    AnalysisProject,
    InformationPositiveNegativeAnalysis,
    NetworkVolumeAnalysis,
    IndustryAnalysis,
    CountryAnalysis,
    BusinessOpportunityAnalysis,
    RiskAnalysis,
    AtlasAnalysis,
    HotWordAnalysis,
    GenerateReport,
    Empty
  },
  data () {
    var self = this
    return {
      graphData:{
      graph:{

      }
      },
      elTabsValue:'country',
      projectShow: false,
      spinShow: false,
      projectShowLabel: '项目列表',
      isSmall: false,
      searchForm: {
        country: [],
        industry: [],
        company: [],
        category: [],
        stage: [],
        amount: [],
        pdate: [],
        date: [],
        keywords: ''
      },
      exportSuccess: 'exportSuccess1',
      countryList: [],
      industryList: [],
      categoryList: [],
      companyList: [],
      stageList: [],
      amountList: [],
      dateList: [],
      queryParams: {},
      hotWordData: [],
      dateOptions: {
        shortcuts: [
          {
            text: this.$t('datePicker.threeMonths'),
            value () {
              const end = self.$moment().format('yyyy-MM-DD')
              const start = self.$moment().subtract(3, 'month').format('yyyy-MM-DD')
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              return [start, end]
            }
          },
          {
            text: this.$t('datePicker.oneYear'),
            value () {
              const end = self.$moment().format('yyyy-MM-DD')
              const start = self.$moment().subtract(1, 'year').format('yyyy-MM-DD')

              return [start, end]
            }
          },
          {
            text: this.$t('datePicker.threeYears'),
            value () {
              const end = self.$moment().format('yyyy-MM-DD')
              const start = self.$moment().subtract(3, 'year').format('yyyy-MM-DD')

              return [start, end]
            }
          }
        ]
      },
      /**/
      myCondition: {},
      /**/
      historyModal: false,
      historyColumns: [
        {
          title: this.$t('table.project.history.columns.top'),
          width: 50,
          slot: 'top',
          align: 'center'
        },
        {
          title: this.$t('table.history.columns.title') ,
          key: 'name',
          slot: 'content'
        },
        {
          title: this.$t('table.project.history.columns.delete'),
          width: 80,
          slot: 'operate',
          align: 'center'
        }
      ],
      historyTableData: [],
      associationWordsList:[],
      isAdvanceSearch: false,
    }
  },
  created () {
    this.getConditions()
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
    this.search()
    this.getGraphData({})
  },
  destroyed () {
    window.removeEventListener('resize',this.handleResize)
  },
  activated() {
    if (this.$route.query.from === 'project' && typeof this.$route.query.myCondition !== 'string') {
      this.myCondition = this.$route.query.myCondition;
      this.fromProjectConditions(this.$route.query.conditions.keywords, this.myCondition);
    }

  },

  methods: {
    delAllHistory(){
      this.$pbrAxios.post('/front/searchHistory/delAllHistory', {"type": "front", "subtype": "analyses"}).then((data) => {
        //this.$iMessage.success(this.$t('message.success.delete'))
        this.getHistoryList()
      })
    },
    chartClick(param,type){
      this.isAdvanceSearch = true;
      this.searchForm[type] = [JSON.stringify({id:param.seriesId,title:param.seriesName})]
      this.elTabsValue = 'project';
      this.search()
    },
    advanceSearchBtnClick (advance) {
      this.isAdvanceSearch = advance

    },
    changeTabState(tab,event){
      if(tab == 'more'){
        console.log("/////",tab, event );
        this.openReportModal()
        return false;
      }else if(tab == 'projectList'){
        this.projectShow = !this.projectShow
      }else if(tab=='project'){
        this.$refs.analysisRef.downFile()
      }
    },
    associationWords(keyword){
      if (keyword && keyword.length > 100){
        //this.$iMessage.error({content: this.$t('message.error.maximum100'), duration: 5})
        return
      }
      // type（0项目搜索   1项目资讯搜索  2商机资讯搜索   3风险资讯搜索   4风险事件搜索  5分析页搜索）

      this.$pbrApis.associationWords({keyword, type: 5}).then(res => {
        if (res.success){
          this.associationWordsList = res.result.models
        }
      })
    },
    hotClick (name) {
      this.searchForm.keywords = name;
      this.search()
    },
    /**
     * 分析页图谱
     * @param conceptId
     * @param ids
     */
    getGraphData({conceptId = '1', ids = ''}){
      this.graphData.graph = {entityList:[],relationList:[]}
      this.$pbrApis.getRelationMapAnalysis({id: '', conceptId, tag:'1', ids}).then(res => {
        console.log('图谱', res)
        if (!res) {
          //this.$iMessage.error({content: this.$t('message.error.server'), duration: 5})
        } else if (res.success) {
          this.graphData.graph = res.result
        }
      })
    },
    /**/
    getConditions () {
      this.$pbrAxios.post('/front/analyses/gconditions', {}).then((data) => {
        this.countryList = data.result.regionModels.children
        this.industryList = data.result.industryModels
        this.categoryList = data.result.typeModels
        this.companyList = data.result.enterpriseModels
        this.stageList = data.result.stageModels
        this.amountList = data.result.amountModels
        this.dateList = data.result.dateModels
      })
    },
    getSearchParams () {
      function filterSearchParams (obj) {
        let arr = []
        obj.forEach((item) => {
          arr.push(JSON.parse(item).id)
        })
        return arr.join()
      }

      function filterSearchParamsName (obj) {
        let arr = []
        obj.forEach((item) => {
          arr.push(JSON.parse(item).title)
        })
        return arr.join()
      }

      return {
        country: filterSearchParams(this.searchForm.country),
        countrystr: filterSearchParamsName(this.searchForm.country),
        industry: filterSearchParams(this.searchForm.industry),
        industrystr: filterSearchParamsName(this.searchForm.industry),
        company: filterSearchParams(this.searchForm.company),
        companystr: filterSearchParamsName(this.searchForm.company),
        category: filterSearchParams(this.searchForm.category),
        categorystr: filterSearchParamsName(this.searchForm.category),
        stage: filterSearchParams(this.searchForm.stage),
        stagestr: filterSearchParamsName(this.searchForm.stage),
        amount: filterSearchParams(this.searchForm.amount),
        amountstr: filterSearchParamsName(this.searchForm.amount),
        date: filterSearchParams(this.searchForm.date),
        datestr: filterSearchParamsName(this.searchForm.date),
        pdate: this.searchForm.pdate.join(','),
        keywords: this.searchForm.keywords
      }
    },
    reset () {
      this.searchForm = {
        country: [],
        industry: [],
        company: [],
        category: [],
        stage: [],
        amount: [],
        pdate:[],
        date: [],
        keywords: ''
      }
      this.search()
    },
    search (id) {

      let str = [], _this = this

      function eachMyCondition (obj) {
        _this.myCondition[obj].list.forEach(o => {
          str.push(JSON.parse(o).title)
        })
      }

      this.myCondition.country ? eachMyCondition('country') : ''
      this.myCondition.industry ? eachMyCondition('industry') : ''
      this.myCondition.category ? eachMyCondition('category') : ''
      this.myCondition.company ? eachMyCondition('company') : ''
      this.myCondition.stage ? eachMyCondition('stage') : ''
      this.myCondition.amount ? eachMyCondition('amount') : ''
      this.myCondition.date ? eachMyCondition('date') : ''
      this.searchForm.keywords ? str.push(this.searchForm.keywords) : ''
      let params = this.getSearchParams()
      if (id && typeof (id) === 'string') {
        params.id = id
      }
      params.searchkey = str.join()
      if (this.searchForm.keywords && this.searchForm.keywords.length > 100){
        //this.$iMessage.error({content: this.$t('message.error.maximum100'), duration: 5})
        return
      }
      this.queryParams = params

      this.spinShow = true;

      this.getHotWord()
    },
    /**/
    openHistory () {
      this.historyModal = true
      this.getHistoryList()
    },
    openReportModal () {
      this.$refs.report.open(this.queryParams)
    },
    showProject () {
      this.projectShow = !this.projectShow
      this.projectShowLabel = this.projectShowLabel === '项目列表' ? '隐藏列表' : '项目列表'
    },
    getHistoryList () {
      this.$pbrAxios.post('/front/analyses/ghconditions', {from: 'cn'}).then((data) => {
        console.log(data)
        this.historyTableData = data.result
      })
    },
    dblclickHistory (row) {
      this.historyModal = false
      this.search(row.id)
      this.historyItemClick(row)
    },
    historyItemClick (row) {
      function clearObj (obj) {
        for (let i in obj) {
          if (obj[i] === '' || obj[i] === null || obj[i] === undefined) {
            delete obj[i]
          }
        }
      }

      clearObj(row.conditions)
      let country = []
      this.countryList.forEach((o, i, arr) => {
        if (o.children) {
          o.children.forEach((c, ic, arrc) => {
            if (row.conditions.country && row.conditions.country.indexOf(c.id) > -1) {
              let newc = Object.assign({}, c)
              country.push(JSON.stringify(newc, ['id', 'title']))
            }
          })
        }
        if (row.conditions.country && row.conditions.country.indexOf(o.id) > -1) {
          let newO = Object.assign({}, o)
          country.push(JSON.stringify(newO, ['id', 'title']))
        }
      })
      let industry = this.industryList.filter((o, i, arr) => {
        return row.conditions.industry && row.conditions.industry.indexOf(o.id) > -1
      }).map((o, i, arr) => JSON.stringify(o))
      let company = this.companyList.filter((o, i, arr) => {
        return row.conditions.company && row.conditions.company.indexOf(o.id) > -1
      }).map((o, i, arr) => JSON.stringify(o))
      let category = this.categoryList.filter((o, i, arr) => {
        return row.conditions.category && row.conditions.category.indexOf(o.id) > -1
      }).map((o, i, arr) => JSON.stringify(o))
      let stage = this.stageList.filter((o, i, arr) => {
        return row.conditions.stage && row.conditions.stage.indexOf(o.id) > -1
      }).map((o, i, arr) => JSON.stringify(o))
      let amount = this.amountList.filter((o, i, arr) => {
        return row.conditions.amount && row.conditions.amount.indexOf(o.id) > -1
      }).map((o, i, arr) => JSON.stringify(o))
      let keywords = row.conditions.keywords || ''
      let name = row.conditions.name || ''
      let pdate = row.conditions.pdate ? row.conditions.pdate.split(',') : []
      let date = this.dateList.filter((o, i, arr) => {
        return row.conditions.date && row.conditions.date.indexOf(o.id) > -1
      }).map((o, i, arr) => JSON.stringify({id: o.id, title: o.title}))
      if (name && name.length > 0) {
        this.advanceSearchBtnClick(false)
      }
      this.searchForm = {
        country,
        industry,
        company,
        category,
        stage,
        amount,
        keywords,
        name,
        pdate,
        date,
      }
      this.isAdvanceSearch = true
      console.log(this.searchForm)
    },
    favIconClass (row) {
      if (row.up) {
        if (this.isDark) {
          return {'fav-icon-dark-active': true}
        }
        return {'fav-icon-active': true}
      } else {
        if (this.isDark) {
          return {'fav-icon-dark': true}
        }
        return {'fav-icon': true}
      }
    },
    fromProjectConditions(keyword, myConditions) {
      if (myConditions.country && myConditions.country.list) {
        this.searchForm.country = myConditions.country.list
      } else {
        this.searchForm.country = []
      }

      if (myConditions.industry && myConditions.industry.list) {
        this.searchForm.industry = myConditions.industry.list
      } else {
        this.searchForm.industry = []
      }

      if (myConditions.category && myConditions.category.list) {
        this.searchForm.category = myConditions.category.list
      } else {
        this.searchForm.category = []
      }

      if (myConditions.company && myConditions.company.list) {
        this.searchForm.company = myConditions.company.list
      } else {
        this.searchForm.company = []
      }

      if (myConditions.stage && myConditions.stage.list) {
        this.searchForm.stage = myConditions.stage.list
      } else {
        this.searchForm.stage = []
      }

      if (myConditions.amount && myConditions.amount.list) {
        this.searchForm.amount = myConditions.amount.list
      } else {
        this.searchForm.amount = []
      }

      if (myConditions.date && myConditions.date.list) {
        this.searchForm.date = myConditions.date.list
      } else {
        this.searchForm.date = []
      }

      if (myConditions.pdate && myConditions.pdate.list) {
        this.searchForm.pdate = myConditions.pdate.list
      } else {
        this.searchForm.pdate = []
      }

      this.searchForm.keywords = keyword

      if(Object.keys(myConditions).length > 0){
        this.isAdvanceSearch = true
      }
      if(keyword !== '' || myConditions) {
        this.search()
      }
    },

    toTopHistory (row) {
      this.$pbrAxios.post('/front/analyses/upconditions', {id: row.id, up: !row.up}).then((data) => {
        if (row.up) {
          row.up = false
          this.$message.success(this.$t('message.success.unUp'))
        } else {
          row.up = true
          this.$message.success(this.$t('message.success.up'))
        }
      })
    },
    delHistory (row) {
      this.$pbrAxios.post('/front/analyses/dhconditions', {id: row.id}).then((data) => {
        this.$message.success(this.$t('message.success.delete'))
        this.getHistoryList()
      })
    },

    getHotWord () {
      this.$pbrAxios.post('/front/analyses/ghotword', this.queryParams).then(res => {
        this.hotWordData = res.result
      }).catch(error => {
        console.log(error)
      })
    },

    exportSuccessful() {
      this.exportSuccess = this.exportSuccess === 'exportSuccess1' ? "exportSuccess2" : "exportSuccess1";
    },

    /**/

    handleResize() {
      let that = this;
      let fullWidth = document.documentElement.clientWidth;
      if (fullWidth <= 768 && !that.isSmall) {
        that.isSmall = true;
      }
      if (fullWidth > 768 && that.isSmall) {
        that.isSmall = false;
      }
    }
  },
  watch: {
    'searchForm.country' (val) {
      if (val && val.length > 0) {
        this.myCondition.country = {
          tag: this.$t('label.country'),
          list: val
        }
      } else {
        delete this.myCondition.country
      }
      let ids = Array.from(new Set(val.map(c => JSON.parse(c).id))).join(',')

      this.getGraphData({ids})
    },
    'searchForm.industry' (val) {
      if (val && val.length > 0) {
        this.myCondition.industry = {
          tag: this.$t('label.industry'),
          list: val
        }
      } else {
        delete this.myCondition.industry
      }
    },
    'searchForm.company' (val) {
      if (val && val.length > 0) {
        this.myCondition.company = {
          tag: this.$t('label.enterprise'),
          list: val
        }
      } else {
        delete this.myCondition.company
      }
    },
    'searchForm.category' (val) {
      if (val && val.length > 0) {
        this.myCondition.category = {
          tag: this.$t('label.category'),
          list: val
        }
      } else {
        delete this.myCondition.category
      }
    },
    'searchForm.stage' (val) {
      if (val && val.length > 0) {
        this.myCondition.stage = {
          tag: this.$t('label.stage'),
          list: val
        }
      } else {
        delete this.myCondition.stage
      }
    },
    'searchForm.amount' (val) {
      if (val && val.length > 0) {
        this.myCondition.amount = {
          tag: this.$t('label.amount'),
          list: val
        }
      } else {
        delete this.myCondition.amount
      }
    },
    'searchForm.pdate' (val) {
      if (val && val.length > 0 && val[0]) {
        this.myCondition.pdate = {
          tag: this.$t('label.signDate'),
          list: val
        }
      } else {
        delete this.myCondition.pdate
      }
    }
  }

}
</script>
<style scoped>
.more-btn{
  cursor: pointer;
}
</style>
